export const statuses = [
  {
    value: 'true',
    label: 'ACTIVE',
  },
  {
    value: 'false',
    label: 'INACTIVE',
  },
];

export const mfaEnabled = [
  {
    value: 'true',
    label: 'ENABLED',
  },
  {
    value: 'false',
    label: 'DISABLED',
  },
];
